import './static-page.css';
import { ThemeToggle, useStaticPageTheme } from './theme-toggle';

export function SupportPage() {
  const { theme, setTheme } = useStaticPageTheme();

  return (
    <div className="static-page">
      <main className="static-page-content">
        <div className="static-page-header">
          <h1>Support</h1>
          <ThemeToggle theme={theme} setTheme={setTheme} />
        </div>
        <p className="subtitle">Strong's KJV Bible App</p>

        <p>
          Need help with Strong's KJV? We're here to assist. Whether you have a question,
          found a bug, or have a feature request, reach out and we'll get back to you.
        </p>

        <h2>Contact Us</h2>
        <p>Send us an email and we'll respond as soon as possible.</p>
        <p>
          <a className="email-btn" href="mailto:support@skjv.ai">support@skjv.ai</a>
        </p>

        <h2>Common Topics</h2>
        <p>
          <strong>App not loading?</strong> Try closing and reopening the app, or clearing the
          app cache in your device settings.
        </p>
        <p>
          <strong>Feature requests?</strong> We love hearing what would make your Bible study
          better. Send us your ideas via email.
        </p>
        <p>
          <strong>Bug reports?</strong> Please include your device model, OS version, and steps
          to reproduce the issue so we can fix it quickly.
        </p>

        <footer>
          <a href="/">Strong's KJV</a> · <a href="/privacy">Privacy Policy</a> ·{' '}
          <a href="/terms">Terms</a>
        </footer>
      </main>
    </div>
  );
}
